<div class="w-full overflow-visible">
  <div class="min-w-full" [style.minWidth.px]="chartMinWidth">
    <div class="flex">
      <div
        class="mr-3 flex w-[36px] flex-col justify-between text-right text-[12px] text-neutral-n4"
        [style.height.px]="barHeight"
      >
        @for (tick of yAxisTicks; track tick) {
          <div>{{ tick }}</div>
        }
      </div>

      <div class="flex-1">
        <div class="relative border-b border-neutral-n5 px-6" [style.height.px]="barHeight">
          @for (tick of yAxisTicks.slice(0, -1); track tick; let index = $index) {
            <div
              class="pointer-events-none absolute left-0 right-0 border-t border-neutral-n6"
              [style.top.%]="index * 20"
            ></div>
          }

          <div
            class="relative grid h-full items-end px-1"
            [style.gridTemplateColumns]="gridTemplateColumns"
            [style.columnGap.px]="groupGap"
          >
            @for (group of columnGroups; track trackGroup($index, group)) {
              <div class="flex h-full min-w-0 items-end justify-center" [style.columnGap.px]="barGap">
                @for (bar of group.bars; track trackBar($index, bar)) {
                  <div
                    class="relative h-full min-w-[30px] flex-1"
                    (mouseenter)="showBarTooltip($event, bar)"
                    (mousemove)="moveBarTooltip($event)"
                    (mouseleave)="hideBarTooltip()"
                  >
                    @if (shouldShowUnansweredProgress(bar)) {
                      <div
                        class="absolute left-1/2 top-[-30px] z-10 h-4 w-4 -translate-x-1/2 rounded-full border-[2px] bg-white p-[1px]"
                        [style.borderColor]="getUnansweredProgressColor(bar)"
                      >
                        <div
                          class="h-full w-full rounded-full"
                          [style.background]="getUnansweredProgressBackground(bar)"
                        ></div>
                      </div>
                    }

                    <button
                      type="button"
                      class="relative h-full min-w-[30px] w-full cursor-pointer rounded-t-[4px] rounded-b-none border-0 bg-neutral-n6 p-0 text-left"
                      [disabled]="!bar.raw"
                      (click)="emitByBar(bar)"
                    >
                      <div
                        class="absolute bottom-0 left-0 right-0 flex items-center justify-center rounded-t-[4px] text-[12px] font-medium text-white"
                        [style.height.%]="bar.correctPercent ?? 0"
                        [style.background]="bar.correctColor"
                      >
                        @if (showBarLabel(bar)) {
                          <span>{{ bar.correctPercent | number:'1.0-0' }}%</span>
                        }
                      </div>
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <div class="mt-3 grid px-7" [style.gridTemplateColumns]="gridTemplateColumns" [style.columnGap.px]="groupGap">
          @for (group of columnGroups; track trackGroup($index, group)) {
            <div class="flex min-w-0 justify-center">
              <button
                type="button"
                class="flex min-h-[32px] items-center justify-center gap-1 rounded-[4px] border px-2 text-[14px] font-medium"
                [class.bg-[#E5F0FF]]="group.axis.active"
                [class.border-primary-b6]="group.axis.active"
                [class.text-primary-b1]="group.axis.active"
                [class.border-transparent]="!group.axis.active"
                [class.text-neutral-n1]="!group.axis.active"
                (click)="emitByAxis(group)"
              >
                @if (group.axis.preferred) {
                  <img [src]="flagBase" class="h-4 w-4 shrink-0" />
                } @else {
                  <span>{{ group.no }}</span>
                }

                @if (group.axis.discussCount > 0) {
                  <span
                    class="flex h-4 min-w-4 items-center justify-center rounded-[10px_10px_10px_0] bg-[#ff0000] px-[3px] text-[10px] font-bold leading-none text-white"
                  >
                    {{ group.axis.discussCount }}
                  </span>
                }
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  @if (tooltipVisible) {
    <div
      class="pointer-events-none fixed z-50 max-w-[220px] rounded bg-white px-3 py-2 text-[14px] leading-5 text-neutral-n1 shadow-[0_2px_8px_rgba(0,0,0,0.15)]"
      [style.left.px]="tooltipLeft"
      [style.top.px]="tooltipTop"
    >
      @for (line of tooltipLines; track $index) {
        <div class="mb-1">{{ line }}</div>
      }
    </div>
  }
</div>
